import { render, staticRenderFns } from "./CustomerAmountSummaryList.vue?vue&type=template&id=39409676&scoped=true&"
import script from "./CustomerAmountSummaryList.vue?vue&type=script&lang=js&"
export * from "./CustomerAmountSummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39409676",
  null
  
)

export default component.exports